import { EPhotoType } from "@/types/backoffice/dto/photo/photo-types.ts";

const photoType: Record<EPhotoType, string> = {
  [EPhotoType.DELIVERY_POINT]: "Point de livraison",
  [EPhotoType.CONTRACT]: "Contrat",
  [EPhotoType.BEFORE_INSTALL_CLOSED]: "Avant installation - Fermé",
  [EPhotoType.BEFORE_INSTALL_OPENED]: "Avant installation - Ouvert",
  [EPhotoType.AFTER_INSTALL_CLOSED]: "Après installation - Fermé",
  [EPhotoType.AFTER_INSTALL_OPENED]: "Après installation - Ouvert",
  [EPhotoType.OTHER]: "Autre",
  [EPhotoType.HEATERS]: "Radiateurs",
  [EPhotoType.INSTALLATION_SHEET_VOLTAPAP]: "Fiche d'installation VOLTAPAP",
  [EPhotoType.ELECTRICAL_BOARD]: "Tableau électrique",
  [EPhotoType.INSTALLATION_SHEET_VOLTINSTALL]: "Fiche d'installation VOLTINSTALL",
  [EPhotoType.CASKET]: "Caisse",
  [EPhotoType.INSTALL_BEFORE_INSTALL]: "Installation - Avant installation",
  [EPhotoType.INSTALL_AFTER_WIRING]: "Installation - Après câblage",
  [EPhotoType.INSTALL_AFTER_REASSEMBLY]: "Installation - Après réassemblage",
  [EPhotoType.UNINSTALL_BEFORE_UNINSTALL]: "Désinstallation - Avant désinstallation",
  [EPhotoType.UNINSTALL_AFTER_REASSEMBLY]: "Désinstallation - Après réassemblage",
  [EPhotoType.BEFORE_WIRING]: "Avant câblage",
  [EPhotoType.INITIAL_INVENTORY]: "Inventaire initial",
  [EPhotoType.APPOINTMENT_COMMITMENT_FORM]: "Formulaire d'engagement de rendez-vous",
  [EPhotoType.ELECTRICITY_BILL]: "Facture d'électricité",
  [EPhotoType.CEE_QUOTE]: "Devis CEE",
  [EPhotoType.NEW_IMPORT_INSTALLATION_SHEET]: "Fiche d'installation",
  [EPhotoType.PROGRAMMING_MODE_STICKER]: "Sticker mode de programmation",
  [EPhotoType.WIRE_MODE]: "Mode fil pilote",
  [EPhotoType.NAME_PLATE]: "Plaque signalétique",
  [EPhotoType.ELECTRICAL_BOARD_AND_HOUSING]: "Tableau & Logement",
  [EPhotoType.RADIATORS_AND_TOWEL_DRYERS]: "Radiateurs & Sèches Serviettes",
  [EPhotoType.HOT_WATER_TANK]: "Ballon d'eau chaude",
};

const referencesLocale = {
  references: {
    photoType,
  },
};

export type ReferencesLocale = typeof referencesLocale;
export default referencesLocale;
